export default "__VITE_ASSET__sfOLNz_A__"